module.exports = __webpack_public_path__ + "static/img/10.cbbe326.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/sp/10.png
// module id = GSm6
// module chunks = 0